// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.product-detail-bottom-sheet {
  /* Override bottom sheet styles for this specific component */
}

.product-detail-sheet-inner {
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: hidden;
  min-height: 0;
}

.product-detail-content {
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: hidden;
  min-height: 0;
}

.product-detail-sheet-scroll {
  flex: 1;
  overflow-y: auto;
  min-height: 0;
  padding: 0 0 16px;
}

/* Custom Header */
.product-detail-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  border-bottom: 1px solid var(--color-light-gray);
  background-color: var(--color-white);
  flex-shrink: 0;
}

.back-button {
  display: flex;
  align-items: center;
  gap: 4px;
  color: var(--color-primary-green);
  font-weight: 500;
  padding: 8px;
  min-width: auto;
}

/* Product Image Section */
.product-image-section {
  padding: 24px 16px;
  display: flex;
  justify-content: center;
  background-color: var(--color-light-gray);
}

.product-image {
  width: 200px;
  height: 200px;
  object-fit: cover;
  border-radius: 12px;
  box-shadow: var(--shadow-sm);
}

.product-image-placeholder {
  width: 200px;
  height: 200px;
  background-color: var(--color-white);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--color-gray);
  box-shadow: var(--shadow-sm);
}

/* Product Info Section */
.product-info-section {
  flex: 1;
  padding: 24px 16px;
  overflow-y: auto;
  min-height: 0;
}

.product-info-header {
  margin-bottom: 24px;
}

.product-brand {
  color: var(--color-dark-gray);
  margin-bottom: 4px;
}

.product-name {
  color: var(--color-black);
  line-height: 1.2;
  margin: 0;
}

.product-details {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.detail-item {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.detail-label {
  color: var(--color-dark-gray);
  font-weight: 500;
}

.detail-value {
  color: var(--color-black);
  line-height: 1.4;
}

.usage-steps {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.usage-step {
  padding-left: 8px;
}

/* Footer */
.product-detail-footer {
  padding: 16px;
  border-top: 1px solid var(--color-light-gray);
  background-color: var(--color-white);
  flex-shrink: 0;
}

.full-page-button {
  width: 100%;
  height: 48px;
}

/* Responsive adjustments */
@media (max-width: 480px) {
  .product-detail-header {
    padding: 12px 16px;
  }
  
  .product-image-section {
    padding: 16px;
  }
  
  .product-image,
  .product-image-placeholder {
    width: 160px;
    height: 160px;
  }
  
  .product-info-section {
    padding: 20px 16px;
  }
  
  .product-details {
    gap: 16px;
  }
  
  .product-detail-footer {
    padding: 12px 16px;
  }
  
  .full-page-button {
    height: 44px;
  }
}

@media (max-width: 360px) {
  .product-image,
  .product-image-placeholder {
    width: 140px;
    height: 140px;
  }
  
  .product-info-section {
    padding: 16px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/bottomdrawers/ProductDetailBottomSheet.css"],"names":[],"mappings":"AAAA;EACE,6DAA6D;AAC/D;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,OAAO;EACP,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,OAAO;EACP,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,aAAa;EACb,iBAAiB;AACnB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,gDAAgD;EAChD,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iCAAiC;EACjC,gBAAgB;EAChB,YAAY;EACZ,eAAe;AACjB;;AAEA,0BAA0B;AAC1B;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,yCAAyC;AAC3C;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,oCAAoC;EACpC,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,wBAAwB;EACxB,4BAA4B;AAC9B;;AAEA,yBAAyB;AACzB;EACE,OAAO;EACP,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,iBAAiB;AACnB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,6CAA6C;EAC7C,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,2BAA2B;AAC3B;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;;IAEE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,YAAY;EACd;AACF;;AAEA;EACE;;IAEE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":[".product-detail-bottom-sheet {\n  /* Override bottom sheet styles for this specific component */\n}\n\n.product-detail-sheet-inner {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  overflow: hidden;\n  min-height: 0;\n}\n\n.product-detail-content {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  overflow: hidden;\n  min-height: 0;\n}\n\n.product-detail-sheet-scroll {\n  flex: 1;\n  overflow-y: auto;\n  min-height: 0;\n  padding: 0 0 16px;\n}\n\n/* Custom Header */\n.product-detail-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 16px;\n  border-bottom: 1px solid var(--color-light-gray);\n  background-color: var(--color-white);\n  flex-shrink: 0;\n}\n\n.back-button {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  color: var(--color-primary-green);\n  font-weight: 500;\n  padding: 8px;\n  min-width: auto;\n}\n\n/* Product Image Section */\n.product-image-section {\n  padding: 24px 16px;\n  display: flex;\n  justify-content: center;\n  background-color: var(--color-light-gray);\n}\n\n.product-image {\n  width: 200px;\n  height: 200px;\n  object-fit: cover;\n  border-radius: 12px;\n  box-shadow: var(--shadow-sm);\n}\n\n.product-image-placeholder {\n  width: 200px;\n  height: 200px;\n  background-color: var(--color-white);\n  border-radius: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--color-gray);\n  box-shadow: var(--shadow-sm);\n}\n\n/* Product Info Section */\n.product-info-section {\n  flex: 1;\n  padding: 24px 16px;\n  overflow-y: auto;\n  min-height: 0;\n}\n\n.product-info-header {\n  margin-bottom: 24px;\n}\n\n.product-brand {\n  color: var(--color-dark-gray);\n  margin-bottom: 4px;\n}\n\n.product-name {\n  color: var(--color-black);\n  line-height: 1.2;\n  margin: 0;\n}\n\n.product-details {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.detail-item {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.detail-label {\n  color: var(--color-dark-gray);\n  font-weight: 500;\n}\n\n.detail-value {\n  color: var(--color-black);\n  line-height: 1.4;\n}\n\n.usage-steps {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.usage-step {\n  padding-left: 8px;\n}\n\n/* Footer */\n.product-detail-footer {\n  padding: 16px;\n  border-top: 1px solid var(--color-light-gray);\n  background-color: var(--color-white);\n  flex-shrink: 0;\n}\n\n.full-page-button {\n  width: 100%;\n  height: 48px;\n}\n\n/* Responsive adjustments */\n@media (max-width: 480px) {\n  .product-detail-header {\n    padding: 12px 16px;\n  }\n  \n  .product-image-section {\n    padding: 16px;\n  }\n  \n  .product-image,\n  .product-image-placeholder {\n    width: 160px;\n    height: 160px;\n  }\n  \n  .product-info-section {\n    padding: 20px 16px;\n  }\n  \n  .product-details {\n    gap: 16px;\n  }\n  \n  .product-detail-footer {\n    padding: 12px 16px;\n  }\n  \n  .full-page-button {\n    height: 44px;\n  }\n}\n\n@media (max-width: 360px) {\n  .product-image,\n  .product-image-placeholder {\n    width: 140px;\n    height: 140px;\n  }\n  \n  .product-info-section {\n    padding: 16px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
